import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Comfortaa:wght@400;700&family=Open+Sans:wght@400;600;700&display=swap');
  
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  
  body {
    font-family: 'Open Sans', sans-serif;
    background-color: #F0F8FF;
    color: #2C3E50;
    line-height: 1.6;
  }
  
  h1, h2, h3, h4, h5, h6 {
    font-family: 'Comfortaa', sans-serif;
    font-weight: 700;
    color: #4169E1;
  }
  
  button {
    cursor: pointer;
    font-family: 'Open Sans', sans-serif;
    font-weight: 600;
    border: none;
    border-radius: 25px;
    padding: 12px 24px;
    font-size: 1rem;
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }
    
    &:active {
      transform: translateY(0);
    }
  }
  
  .primary-btn {
    background-color: #4169E1;
    color: white;
  }
  
  .secondary-btn {
    background-color: #FF9500;
    color: white;
  }
  
  .success {
    color: #32CD32;
  }
  
  .error {
    color: #FF4757;
  }
  
  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }
  
  @media (max-width: 768px) {
    h1 {
      font-size: 1.8rem;
    }
    
    h2 {
      font-size: 1.5rem;
    }
    
    button {
      padding: 10px 20px;
    }
  }
`;

export default GlobalStyles;
